import { defineRouter } from "#q-app";
import {
  createRouter,
  createMemoryHistory,
  createWebHistory,
  createWebHashHistory,
} from "vue-router";
import { LocalStorage } from "quasar";
import routes from "./routes";
import { isStaleChunkError, reloadForStaleChunk } from "@/utils/stale-chunk";

// eslint-disable-next-line
export default defineRouter((/* { ssrContext } */) => {
  let createHistory = null;
  if (import.meta.env.QUASAR_SERVER) {
    createHistory = createMemoryHistory;
  } else {
    createHistory =
      import.meta.env.QUASAR_VUE_ROUTER_MODE === "history"
        ? createWebHistory
        : createWebHashHistory;
  }

  const Router = createRouter({
    scrollBehavior: () => ({ left: 0, top: 0 }),
    routes,

    // Leave this as is and make changes in quasar.config.js instead!
    // quasar.config.js -> build -> vueRouterMode
    // quasar.config.js -> build -> publicPath
    // eslint-disable-next-line
    history: createHistory(import.meta.env.QUASAR_VUE_ROUTER_BASE),
  });

  // vue-router 5 deprecated the next() callback: return the value instead.
  Router.beforeEach((to) => {
    if (
      to.matched.some((record) => record.meta.requiresAuth) &&
      LocalStorage.has("d_token") === false
    ) {
      return "/auth/login";
    }
  });

  // A new deploy replaces the hashed lazy-route chunks (e.g. Show-<hash>.js).
  // Tabs opened before the deploy still reference the old hashes, so navigating
  // to a lazy route throws "Failed to fetch dynamically imported module".
  // Recover by reloading to the intended route, which fetches the fresh
  // index.html + current chunk hashes. Detection and recovery live in
  // @/utils/stale-chunk, because the lazy imports inside pages hit the same
  // wall and need the same answer.
  Router.onError((error, to) => {
    if (!isStaleChunkError(error)) return;
    reloadForStaleChunk(to && to.fullPath);
  });

  return Router;
});
